
import { useEffect, useState } from "react";
import { styled } from "@mui/styles";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import { ReactComponent as TrashIcon } from "../../assets/icons/trash.svg"
import ConfirmDialog from "../ConfirmDialog";

import scheduleService from '../../services/schedule.service'

const StopScheduleButton = (props) => {
  const { id, status, onSuccess, onError } = props;

  const [showConfirm, setShowConfirm] = useState(false)

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));


  const stopTask = () => {
    if (id && status) {
      setShowConfirm(true)
    }
  }

  const processStop = async () => {
    setShowConfirm(false)

    try {
      const resp = await scheduleService.stop(id)
      console.log('scheduleService.stop', resp)

      if (onSuccess) onSuccess()

    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <BootstrapTooltip title={`Stop`} placement="top" onClick={stopTask}>
        <TrashIcon style={{ marginRight: "10px", cursor: "pointer" }} />
      </BootstrapTooltip>

      <ConfirmDialog open={showConfirm} warning={true} doConfirm={processStop} setValue={() => setShowConfirm(false)} title="Confirmation of Stop Task" text={`Are you sure to stop this Task ?`} />
    </>
  )

}


export default StopScheduleButton;
